module.exports = __webpack_public_path__ + "f8c1b9ad65b52353c554b8d6e7735522.svg";